import {createContext, useState} from "react";

export const AuthContext = createContext();

/**
 * Jwt Token Provider
 * @param children
 * @returns {JSX.Element}
 * @constructor
 */
const AuthProvider = ({children}) => {
    const [token, setToken] = useState("");
    const [isAuthenticated, setAuthenticated] = useState(false);
    const [tokenExpiresIn, setTokenExpiresIn] = useState(null);
    const [role, setRole] = useState("");
    const [user, setUser] = useState({});

    const saveToken = (data) => {
        setToken(data);
    };

    function saveAuthenticated (data) {
        setAuthenticated(data);
    };

    const saveTokenExpiresIn = (data) => {
        setTokenExpiresIn(data);
    };

    const saveRole = (data) => {
        setRole(data);
    };

    const saveUser = (data) => {
        setUser(data);
    };

    const contextValue = {
        token,
        saveToken ,
        isAuthenticated,
        saveAuthenticated,
        tokenExpiresIn,
        saveTokenExpiresIn ,
        role,
        saveRole,
        user,
        saveUser
    }

    return (
        <AuthContext.Provider value={ contextValue }>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthProvider;